<template>
  <!-- 25.9.16 联系方式 dxm -->
  <div class="flex flex_wrap">
    <div
      class="contact_wrap flex"
      v-for="(item, index) in list"
      :key="index"
      @click="toLink(item)"
    >
      <img class="images" :src="item.img" alt="" />
      <div class="contact_content">
        <div class="title">
          {{ langSet == "cn" ? item.remarks : item.en_remarks }}
        </div>
        <div>{{ langSet == "cn" ? item.nickname : item.en_nickname }}</div>
        <div v-if="item.type == 2">{{ item.tel }}</div>
        <div class="con_btn" v-if="item.type != 2">
          {{ langSet == "cn" ? "获取联系方式" : "Contact Information" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },
  data() {
    return {
      langSet: "",
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    toLink(item) {
      if (item.type != 2) {
        window.open(
          "https://tianbao.apichina.com.cn/ex-register/register",
          "_blank"
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contact_wrap {
  width: 580px;
  height: 153px;
  color: #001a33;
  box-sizing: border-box;
  background: #f9fafc;
  border-radius: 30px;
  margin-right: 40px;
  margin-top: 57px;
  &:nth-child(2n) {
    margin-right: 0;
  }
  .images {
    width: 180px;
    height: 180px;
    background: #ccc;
    position: relative;
    top: -20px;
    border-radius: 30px;
  }
  .contact_content {
    flex: 1;
    font-size: 18px;
    color: #001a33;
    line-height: 25px;
    padding: 37px 20px 0 30px;
    position: relative;
    .title {
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 6px;
    }
    .con_btn {
      min-width: 138px;
      height: 40px;
      font-size: 14px;
      color: #44435a;
      cursor: pointer;
      line-height: 40px;
      text-align: center;
      background: #fff;
      border-radius: 8px;
      position: absolute;
      bottom: 13px;
      right: 20px;
      z-index: 9;
      padding: 0 10px;
      box-sizing: border-box;
      border: 1px solid #1d2379;
      &:hover {
        color: #fff;
        background: #1d2379;
        transition: all 0.3s linear;
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
  .contact_wrap {
    width: calc((100% - 20px) / 2);
    margin-right: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .contact_wrap {
    width: 100%;
    height: 2.88rem;
    padding: 0.28rem;
    font-size: 0.27rem;
    line-height: 0.38rem;
    background: #f7f8fa;
    margin-right: 0;
    margin-top: 0.38rem;
    border-radius: 20px;
    &:nth-child(2n) {
      margin-right: 0;
    }
    > div {
      margin-top: 0.19rem;
    }
    .contact_title {
      font-size: 0.31rem;
      font-weight: 500;
      margin-bottom: 0.21rem;
    }
    .images {
      width: 2.31rem;
      height: 2.31rem;
      top: 0;
      border-radius: 10px;
    }
    .contact_content {
      font-size: 0.27rem;
      line-height: 0.38rem;
      padding: 0.19rem 0.29rem;
      .title {
        font-size: 0.29rem;
        line-height: 0.4rem;
        margin-bottom: 0.19rem;
      }
      .con_btn {
        width: 1.88rem;
        height: 0.54rem;
        color: #fff;
        right: 0;
        bottom: 5px;
        line-height: 0.54rem;
        font-size: 0.23rem;
        background: #1d2379;
        border-radius: 0.27rem;
      }
    }
    .icon {
      width: 0.35rem;
      margin-right: 0.12rem;
    }
  }
}
</style>